import { RoutePaths } from '@interfaces/routePaths'
import { Base } from '@views/Activity/Base'
import { BaseLayout } from '../BaseLayout'

export const ACTIVITY_PATHS = [
  {
    path: RoutePaths.ACTIVITY,
    element: <BaseLayout />,
    children: [
      {
        index: true,
        element: <Base />,
      },
    ],
  },
]
